import React, { useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import ST from "../../assets/styles/organisms/chatMessageHistory.module.scss";

type Props = {
  placeholder?: string;
  onClick?: (query: string | undefined) => void;
};

const ChatHistorySearchBox: React.FC<Props> = ({ placeholder, onClick }) => {
  const [query, setQuery] = useState<string | undefined>(undefined);

  const handleOnClick = () => {
    onClick?.(query);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleOnClick();
    }
  };

  return (
    <div className={ST.search_box}>
      <input
        className={ST.search_input}
        type="search"
        placeholder={placeholder}
        onChange={(e) => setQuery(e.target.value || undefined)}
        onKeyDown={handleKeyPress}
      />
      <button
        type="button"
        className={ST.search_button}
        onClick={handleOnClick}
        aria-label="検索"
      >
        <SearchIcon fontSize="small" />
      </button>
    </div>
  );
};

export default ChatHistorySearchBox;
